<template>
  <el-dialog
    title="Импорт платежей из банка"
    append-to-body
    :visible="visible"
    :width="isMobile ? '90%' : '40%'"
    @close="beforeClose"
  >
    <loader-wrapper :loading="loading">
      <h3 class="import-h3">
        Выберите файл импорта и нажмите кнопку загрузить
      </h3>
      <el-upload
        ref="upload"
        :multiple="false"
        :auto-upload="false"
        :http-request="customUpload"
        action=""
      >
        <el-button slot="trigger" size="small" type="primary">
          Выберите файл
        </el-button>
        <el-button
          type="success"
          size="small"
          :loading="loading"
          style="margin-left: 10px"
          @click="onSubmit"
        >
          Загрузить
        </el-button>
      </el-upload>
    </loader-wrapper>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const Payments = RepositoryFactory.get('payments')

export default {
  name: 'UploadDocModal',
  components: { LoaderWrapper },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close')
    },
    customUpload(file) {
      this.loading = true
      const param = new FormData()

      param.append('file', file.file)
      Payments.updateDates(param)
        .then(res => {
          if (res.status === 200) {
            this.$message.success('Даты успешно обновлены')
            this.$refs.upload.clearFiles()
            this.beforeClose()
          }
        })
        .catch(e => this.errHandler(e))
        .finally(() => (this.loading = false))
    },
    onSubmit() {
      this.$refs.upload.submit()
    },
  },
}
</script>

<style lang="sass">
.import-h3
  font-family: "Rubik", sans-serif;
  font-weight: normal;
</style>
